<template>
  <section v-if="loading || error || needsLogin || model.visible || financialRecovery" class="booking-recovery" :role="error ? 'alert' : 'status'" aria-live="polite">
    <p v-if="loading">{{ copy.loading }}</p>
    <p v-else-if="needsLogin">{{ copy.login }} <router-link :to="{name:'login',params:{lang}}">{{ copy.loginCta }}</router-link></p>
    <template v-else-if="error">
      <h3>{{ copy.errorTitle }}</h3><p>{{ copy.errorBody }}</p>
    </template>
    <template v-else>
      <template v-if="model.visible">
        <h3>{{ model.title }}</h3><p>{{ model.body }}</p>
        <p v-if="model.reference">{{ copy.reference }}: <bdi>{{ model.reference }}</bdi></p>
        <p v-if="model.heldUntilLabel">{{ copy.deadline }}: <bdi>{{ model.heldUntilLabel }}</bdi></p>
      </template>
      <aside v-if="financialRecovery" class="financial-recovery">
        <h3>{{ financialRecovery.title }}</h3><p>{{ financialRecovery.body }}</p>
        <p v-if="financialRecovery.reference">{{ copy.reference }}: <bdi>{{ financialRecovery.reference }}</bdi></p>
        <router-link v-if="financialRecovery.cartId" class="btn btn-secondary btn-sm" :to="{name:'portalReceipt',params:{lang},query:{id:financialRecovery.cartId}}">{{ copy.invoice }}</router-link>
      </aside>
    </template>
    <div v-if="!loading && !needsLogin" class="actions">
      <button class="btn btn-secondary btn-sm" type="button" @click="load">{{ copy.refresh }}</button>
      <router-link v-if="!error && model.cartId" class="btn btn-secondary btn-sm" :to="{name:'portalReceipt',params:{lang},query:{id:model.cartId}}">{{ copy.invoice }}</router-link>
      <router-link v-if="!error && model.status === 'CONFIRMED'" class="btn btn-primary btn-sm" :to="{name:'portalSessions',params:{lang}}">{{ copy.sessions }}</router-link>
      <router-link class="btn btn-secondary btn-sm" :to="{name:'portalSupport',params:{lang}}">{{ copy.support }}</router-link>
    </div>
  </section>
</template>
<script>
import {fetchActiveBookingStatus, hasAuthToken} from '@/intake/portalApi'
import {bookingRecoveryModel, financialRecoveryModel} from '@/intake/bookingRecovery'

export default {
  name: 'BookingRecoveryNotice',
  props: {lang: {type: String, default: 'fa'}},
  data: () => ({loading: true, error: false, needsLogin: false, projection: null, generation: 0}),
  computed: {
    model() { return bookingRecoveryModel(this.projection, this.lang) },
    financialRecovery() { return financialRecoveryModel(this.projection, this.lang) },
    copy() {
      return this.lang === 'fa'
        ? {loading:'در حال بررسی وضعیت رزرو…',login:'برای بررسی رزرو وارد حساب شوید.',loginCta:'ورود به حساب',errorTitle:'وضعیت رزرو دریافت نشد',errorBody:'پیش از رزرو یا پرداخت دوباره، وضعیت را بررسی کنید. اگر مبلغی از حساب شما کم شده، رسید بانکی را برای پشتیبانی بفرستید.',reference:'کد رزرو',deadline:'پایان مهلت رزرو',refresh:'بررسی دوبارهٔ وضعیت',invoice:'مشاهدهٔ فاکتور',sessions:'مشاهدهٔ جلسات',support:'درخواست پشتیبانی'}
        : {loading:'Checking booking status…',login:'Sign in to check your booking.',loginCta:'Sign in',errorTitle:'Booking status could not be loaded',errorBody:'Check the status before booking or paying again. If your account was charged, send support the bank receipt.',reference:'Booking code',deadline:'Hold deadline',refresh:'Refresh status',invoice:'View invoice',sessions:'View sessions',support:'Contact support'}
    },
  },
  mounted() { return this.load() },
  beforeDestroy() { this.generation += 1 },
  methods: {
    load() {
      if (this.loading && this.generation) return
      const generation = ++this.generation
      this.loading = true; this.error = false; this.needsLogin = false; this.projection = null
      this.$emit('change', {status:'LOADING', blocksNewBooking:true})
      if (!hasAuthToken()) {
        this.loading = false
        this.needsLogin = true
        this.$emit('change', {status:'AUTH_REQUIRED', blocksNewBooking:true})
        return Promise.resolve()
      }
      return fetchActiveBookingStatus().then((projection) => {
        if (generation !== this.generation) return
        this.projection = projection
        this.$emit('change', this.model)
      }).catch(() => {
        if (generation !== this.generation) return
        this.error = true
        this.$emit('change', {status:'ERROR', blocksNewBooking:true})
      }).finally(() => {
        if (generation === this.generation) this.loading = false
      })
    },
  },
}
</script>
<style scoped>
.booking-recovery { padding: 1.1rem; margin-block: 1rem; border: 1px solid #a7dcd6; border-radius: 1rem; background: #f0fbf9; color: #154356; }
.booking-recovery h3 { margin: 0 0 .5rem; font-size: 1.05rem; }
.booking-recovery p { line-height: 1.9; }
.booking-recovery .actions { display: flex; flex-wrap: wrap; gap: .5rem; }
.financial-recovery { margin-block: .9rem; padding-block-start: .75rem; border-block-start: 1px solid #c7e4df; }
</style>
